module.exports = __webpack_public_path__ + "static/media/counselingCenter.cd1e294d.png";